import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=95c3627a&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=95c3627a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c3627a",
  null
  
)

export default component.exports